import styled from 'styled-components';

const StyledCardsSeparator = styled.div`
  min-width: 32px;
  background: ${({ theme, backgroundSkin }) =>
    theme.base.colorSchema[backgroundSkin] || 'var(--grey800)'};
  display: flex;
  padding: ${({ theme }) => theme.base.gridSizes.S} 0;

  span {
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    transform: rotate(-90deg) translate(-100%, 0);
    display: block;
    transform-origin: top left;
    height: 32px;
    line-height: 32px;
  }
`;

export default StyledCardsSeparator;
